/* eslint-disable no-console */
import React from 'react';
import Chart from 'react-apexcharts';

export default function ApexLineChart(props) {
  const { lineChartData, linevalue } = props;
  const xAxis_title = '% Recovery';
  let yAxis_title = '';
  const series_data = [];
  if (linevalue === 'S&DI/LSI') {
    if (lineChartData) {
      series_data.push({
        'name': 'LSI',
        data: lineChartData.lsi || []
      });
      const emptySlots = new Array(lineChartData.lsi.length).fill(null);
      series_data.push({
        'name': 'SDI',
        data: emptySlots.concat(lineChartData.sdi) || []
      });
    } else {
      series_data.push({
        'name': '',
        data: []
      });
    }
    yAxis_title = 'S&DI/LSI';
  } else {
    if (lineChartData) {
      if (lineChartData['IP/KSP'].length !== 0) {
        if (lineChartData['IP/KSP']) {
          series_data.push({
            'name': 'IP/KSP',
            data: lineChartData['IP/KSP'] ? lineChartData['IP/KSP'] : []
          });
        };
        if (lineChartData.Limit) {
          series_data.push({
            'name': 'Limit',
            data: lineChartData.Limit ? lineChartData.Limit : []
          });
        };
      } else {
        series_data.push({
          'name': '',
          data: []
        });
      }
    } else {
      series_data.push({
        'name': '',
        data: []
      });
    }
    yAxis_title = 'IP/KSP & Limit';
  };
  const options = {
    series: series_data,
    chart: {
      height: 350,
      type: 'line',
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },
      parentHeightOffset: 0,
    },
    colors: ['#1768B4', '#21a577'],
    stroke: {
      curve: 'smooth',
      width: 1.5
    },
    noData: {
      text: 'No Data',
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: '12px',
      }
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5
      }
    },
    markers: {
      size: 0
    },
    xaxis: {
      type: 'numeric',
      // categories: [lineChartRecoveryData],
      title: {
        text: xAxis_title
      },
      min: 0,
      max: 100,
      tickAmount: 9,
      // labels: {
      //   formatter (val) {
      //     return val!==undefined?`${Number(val).toFixed(2)  }`:'0';
      //   },
      // }
    },
    yaxis: {
      title: {
        text: yAxis_title
      },
      // min: 0,
      // max: 140,
      // tickAmount: 7,
      labels: {
        formatter(val) {
          return val !== undefined ? `${Number(val).toFixed(2)}` : '0';
        },
      }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      floating: true,
      offsetY: -1,
      offsetX: 5
    }
  };
  return (
    <Chart options={options} series={options.series} type="line" width="100%" height='210' />
  );
}
